/* eslint-disable import/no-unresolved */

import { createVueApp } from '@vuejs/entry';
import PhilantrophyNewsletterApp from '@vuejs/apps/PhilantrophyNewsletterApp.vue';

document.addEventListener('DOMContentLoaded', () => {
    const mountPoint = document.querySelector('#philantrophy-newsletter-app');

    if (mountPoint) {
        const app = createVueApp(PhilantrophyNewsletterApp);
        app.mount(mountPoint);
    }
});
